import { push } from 'connected-react-router';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { ROUTE_PATH } from '../../../app/constants';
import { licenceSubTypeString } from '../../../app/utils';
import { Button } from '../../../components/RegularComponents';
import * as  CONST from '../../../app/constants';

export default function BLTHomeFilter(props) {
    
    const {presetSearchText, presetLicenceTypeOption, presetSortType, setPage} = props

    const dispatch = useDispatch()
    
    const licenceTypeOptions = [
        {
            value: "ALL"
        },
        {
            value: "COLLECTION_AGENCY_APPLICATION"
        },
        // {
        //     value: "COLLECTION_COLLECTOR_APPLICATION"
        // },
        {
            value: "DEBT_MANAGEMENT_APPLICATION"
        },
        // {
        //     value: "DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION"
        // },
        {
            value: "MORTGAGE_BROKERAGE_NEW_APPLICATION"
        },
        {
            value: "PRINCIPAL_BROKER_NEW_APPLICATION"
        },
        {
            value: "MORTGAGE_BROKER_NEW_APPLICATION"
        },
        {
            value: "ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION"
        },
        {
            value: "MORTGAGE_LENDER_NEW_APPLICATION"
        },
        {
            value: "MORTGAGE_ADMINISTRATOR_NEW_APPLICATION"
        }
    ]

    const licenceRenewalTypeOptions = {
        COLLECTION_AGENCY_APPLICATION: CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL,
        COLLECTION_COLLECTOR_APPLICATION: CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL,
        DEBT_MANAGEMENT_APPLICATION: CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL,
        DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION:
            CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL,
        MORTGAGE_BROKERAGE_NEW_APPLICATION:
            CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION,
        PRINCIPAL_BROKER_NEW_APPLICATION: CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION,
        MORTGAGE_BROKER_NEW_APPLICATION: CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
        ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION:
            CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
        MORTGAGE_LENDER_NEW_APPLICATION: CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION,
        MORTGAGE_ADMINISTRATOR_NEW_APPLICATION:
            CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION
    };
    
    let presetOption = presetLicenceTypeOption
    if(presetLicenceTypeOption) {
        presetOption = presetLicenceTypeOption?.split(",")?.[0]
    }
    const [licenceTypeOption, setLicenceTypeOption] = useState(presetOption)
    const [licenceTypeText, setLicenceTypeText] = useState(presetSearchText)
    
    const licenceTypeOptionElements = licenceTypeOptions.map((opt, index) => {
        return (
            <option 
                key={`licence-type-option-${index}`} 
                value={opt.value}>
                {opt.value ? licenceSubTypeString(opt.value) : opt.label} 
            </option>
        )
    })

    const onFilterChange = (e) => {
        const licenceTypeSelected = e.target.value;
        if(setPage) {
            //reset page on new request
            setPage(1);
        }

        if(licenceTypeSelected === CONST.LICENCE_SUB_TYPE_ALL && !licenceTypeText) {
            dispatch(push(ROUTE_PATH.BLT_HOME))
        }
        else {
            let url = ROUTE_PATH.BLT_HOME_SEARCH
            if(licenceTypeText) {
                url += `?licenceTypeText=${licenceTypeText}`;
                if(licenceTypeSelected && licenceTypeSelected !== CONST.LICENCE_SUB_TYPE_ALL) {
                    url += `&licenceTypeOption=${licenceTypeSelected},${licenceRenewalTypeOptions[licenceTypeSelected]}`
                }
            }
            else if(licenceTypeSelected && licenceTypeSelected !== CONST.LICENCE_SUB_TYPE_ALL) {
                url += `?licenceTypeOption=${licenceTypeSelected},${licenceRenewalTypeOptions[licenceTypeSelected]}`
            }

            if(presetSortType) {
                url += `&sortType=${presetSortType}`
            }

            dispatch(push(url))
        }
       
        setLicenceTypeOption(licenceTypeSelected);
    }

    const onSearchClick = async () => { 
        if(setPage) {
            //Reset page for new search
            setPage(1);
        }
       
        if(!licenceTypeText) {
            dispatch(push(ROUTE_PATH.BLT_HOME))
            return;
        }

        let url = ROUTE_PATH.BLT_HOME_SEARCH + `?licenceTypeText=${licenceTypeText}`
        if(licenceTypeOption && licenceTypeOption !== CONST.LICENCE_SUB_TYPE_ALL) {
            url += `&licenceTypeOption=${licenceTypeOption},${licenceRenewalTypeOptions[licenceTypeOption]}`
        }

       dispatch(push(url))
    }

    return (
        <>
            <div className="col-lg-12">
                <h2>Search licensees by licence type and keyword</h2>
            </div>
            <div className="col-lg-12">
                <div className="searchPanel">
                    <div className="col-lg-4">
                        <fieldset>
                            <div>
                                <label
                                    className="ns-label" 
                                    id={"licence-type-select-label"}
                                    htmlFor={"licence-type-select-input"}>
                                        Select a licence type
                                </label>
                                <div className="select">
                                    <select
                                        id={"licence-type-select-input"}
                                        name={"licence-type-select-input"}
                                        value={licenceTypeOption ? licenceTypeOption : "All"}
                                        onChange={onFilterChange}>
                                            {licenceTypeOptionElements}
                                    </select>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <div className="col-lg-7">
                        <fieldset>
                            <div>
                                <label
                                    className="ns-label"
                                    htmlFor={'filter-search-form-text'}
                                    id={"filter-search-form-label"}>
                                        Keywords (company name, location, person or licence number)
                                </label>
                                <input 
                                    style={{height: "2.8em"}}
                                    id={"filter-search-form-text"} 
                                    name={"filter-search-form-text"}
                                    className="ns-input"
                                    autoComplete="licence-type" 
                                    type={"text"} 
                                    value={licenceTypeText} 
                                    onInput={(e) => setLicenceTypeText(e.target.value)} />
                            </div>
                        </fieldset> 
                    </div>
                    <div className="col-lg-1">
                        <Button 
                            id="home-filter-search-button"
                            style={{height: "2.8em"}}
                            buttonType={"regular_success"}
                            text="Search"
                            onClick={onSearchClick}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
